import * as React from "react";
const SvgClock4 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 512, height: 512, style: {
  fill: "none"
} })), /* @__PURE__ */ React.createElement("g", { id: "dark" }, /* @__PURE__ */ React.createElement("path", { d: "M381.3,143.81A183.67,183.67,0,0,0,261.35,94.24a5.75,5.75,0,0,0-5.9,5.76V264.15a5.76,5.76,0,0,0,9.83,4.07L381.42,152.08A5.77,5.77,0,0,0,381.3,143.81Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M255.45,278.45H433.89a5.75,5.75,0,0,0,5.76-5.91,183.6,183.6,0,0,0-50-120.36,5.76,5.76,0,0,0-8.26-.11l-126,126Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M261.35,462.66a183.65,183.65,0,0,0,120-49.62,5.77,5.77,0,0,0,.12-8.27L265.28,288.58a5.76,5.76,0,0,0-9.83,4.08V456.9A5.74,5.74,0,0,0,261.35,462.66Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M255.14,278.45h-.09l-126,126a5.75,5.75,0,0,0,.1,8.26,183.64,183.64,0,0,0,120.37,50,5.75,5.75,0,0,0,5.91-5.76V278.75Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M439.65,284.36a5.75,5.75,0,0,0-5.76-5.91H255.45v.3l126,126a5.77,5.77,0,0,0,8.27-.11A183.6,183.6,0,0,0,439.65,284.36Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M255.1,278.4l-126-126a5.76,5.76,0,0,0-8.27.12,183.61,183.61,0,0,0-49.61,120A5.75,5.75,0,0,0,77,278.45H255.05Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M255.45,278.06V100a5.76,5.76,0,0,0-5.91-5.76,183.65,183.65,0,0,0-120.32,49.92,5.76,5.76,0,0,0-.11,8.26l126,126Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M71.24,284.36A183.59,183.59,0,0,0,120.81,404.3a5.75,5.75,0,0,0,8.27.12L245.22,288.28a5.76,5.76,0,0,0-4.07-9.83H77A5.75,5.75,0,0,0,71.24,284.36Z", style: {
  fill: "#b4dffe",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M323.57,42V53.33a9,9,0,0,1-9,9h-8.21V85.68a7.58,7.58,0,0,1-7.59,7.58H210.52a7.58,7.58,0,0,1-7.59-7.58V62.34h-8.21a9,9,0,0,1-9-9V42a9,9,0,0,1,9-9H314.55A9,9,0,0,1,323.57,42Z", style: {
  fill: "#1870af"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 255.04, cy: 278.93, r: 189.16, style: {
  fill: "none",
  stroke: "#003e6b",
  strokeMiterlimit: 10,
  strokeWidth: 5
} }), /* @__PURE__ */ React.createElement("circle", { cx: 255.3, cy: 278.93, r: 26.26, style: {
  fill: "#1870af",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("circle", { cx: 255.3, cy: 278.93, r: 192.7, style: {
  fill: "none",
  stroke: "#1870af",
  strokeMiterlimit: 10,
  strokeWidth: 13
} }), /* @__PURE__ */ React.createElement("path", { d: "M202.93,62.34h-8.21a9,9,0,0,1-9-9V42a9,9,0,0,1,9-9H314.55a9,9,0,0,1,9,9V53.33a9,9,0,0,1-9,9H202.93Z", style: {
  fill: "#003e6b",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M435.59,462.72c0,19-27.73,17.23-63.85,17.23-35.59,0-39.45-15-39.55-33.63a189.45,189.45,0,0,0,51.51-34.09C413.81,418.27,435.59,445.85,435.59,462.72Z", style: {
  fill: "#003e6b",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }), /* @__PURE__ */ React.createElement("path", { d: "M177.08,446c-.05,18.83-3.72,34-39.55,34-36.12,0-63.85,1.81-63.85-17.23,0-17,22.1-44.85,52.55-50.63A189.63,189.63,0,0,0,177.08,446Z", style: {
  fill: "#003e6b",
  stroke: "#daedfb",
  strokeMiterlimit: 10,
  strokeWidth: 9
} }))));
export default SvgClock4;
